import { render, staticRenderFns } from "./LanguagesSort.vue?vue&type=template&id=12997a52&"
import script from "./LanguagesSort.vue?vue&type=script&lang=js&"
export * from "./LanguagesSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports